import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isFunction } from '@util/utils';
import { Button, Form, Grid, MenuItem, SelectField, Stack, TextField } from "@curves/ui-base";
import clsx from 'clsx';

const TodoInput = ({ className, options, onAddTodo }) => {
    const [selectedTodo, setSelectedTodo] = useState('');

    const inputTextRef = useRef(null);

    // 是否顯示文字輸入框
    const showInputText = selectedTodo === '其他';

    // 當使用者選擇下拉選單的值時，更新 `selectedTodo`
    const handleTodoSelection = (e) => {
        const value = e.target.value;
        setSelectedTodo(value);
    };

    // 表單提交處理
    const handleSubmit = (e) => {
        const textInputValue = inputTextRef.current?.getResult?.() || '';

        isFunction(onAddTodo) && onAddTodo(selectedTodo === '其他' ? textInputValue : selectedTodo);
        setSelectedTodo('');
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Stack alignItems="start" className={clsx('todo__input', className)} spacing="2">
                <Grid className="w-100" spacing="2" container>
                    <Grid xs={showInputText ? 4 : 12} item>
                        <SelectField
                            label="新增事項"
                            key={selectedTodo}
                            defaultValue={selectedTodo}
                            className="todo__select"
                            onChange={handleTodoSelection}
                            displayEmpty
                            fullWidth
                        >
                            <MenuItem disabled value="">
                                <em>請選擇</em>
                            </MenuItem>
                            {!isEmpty(options) &&
                                options.map(({ text, value, disabled }) => (
                                    <MenuItem key={value} value={value} disabled={disabled}>
                                        {text}
                                    </MenuItem>
                                ))}
                        </SelectField>
                    </Grid>
                    {showInputText && (
                        <Grid xs={8} item>
                            <TextField ref={inputTextRef} reserveLabelSpace fullWidth />
                        </Grid>
                    )}
                </Grid>
                <Button type="submit" variant="contained" className="todo__button">
                    新增事項
                </Button>
            </Stack>
        </Form>
    );
};

TodoInput.propTypes = {
    className: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            disabled: PropTypes.bool,
        }),
    ).isRequired,
    onAddTodo: PropTypes.func.isRequired,
};

export default TodoInput;
